module.exports = __webpack_public_path__ + "static/media/on-infinite.383aa9e3.png";